import { render, staticRenderFns } from "./dashboardChart.vue?vue&type=template&id=0ddb619f&"
import script from "./dashboardChart.vue?vue&type=script&lang=js&"
export * from "./dashboardChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports